import { fetchProfile, login, logout, register } from '../../api/storefront'

export default {
  namespaced: true,
  state: { token: localStorage.getItem('ES_TOKEN') || '', user: null, loading: false, error: '' },
  getters: { isLoggedIn: state => !!state.token, user: state => state.user },
  mutations: {
    SET (state, { key, value }) { state[key] = value },
    SESSION (state, payload) {
      state.token = payload.token || ''
      state.user = payload.user || null
      if (state.token) localStorage.setItem('ES_TOKEN', state.token)
      else localStorage.removeItem('ES_TOKEN')
    }
  },
  actions: {
    async restore ({ state, commit }) {
      if (!state.token) return
      try { const response = await fetchProfile(); commit('SET', { key: 'user', value: response.data }) }
      catch (_) { commit('SESSION', {}) }
    },
    async login ({ commit, dispatch }, credentials) {
      commit('SET', { key: 'loading', value: true }); commit('SET', { key: 'error', value: '' })
      try {
        const response = await login(credentials)
        commit('SESSION', { token: response.data.token, user: response.data })
        await dispatch('restore')
      } catch (error) { commit('SET', { key: 'error', value: error.message }); throw error }
      finally { commit('SET', { key: 'loading', value: false }) }
    },
    async register ({ commit, dispatch }, payload) {
      commit('SET', { key: 'loading', value: true }); commit('SET', { key: 'error', value: '' })
      try {
        const response = await register({ ...payload, type: 2, re_password: payload.password })
        commit('SESSION', { token: response.data.token, user: response.data })
        await dispatch('restore')
      } catch (error) { commit('SET', { key: 'error', value: error.message }); throw error }
      finally { commit('SET', { key: 'loading', value: false }) }
    },
    async logout ({ commit }) { try { await logout() } catch (_) {} finally { commit('SESSION', {}) } }
  }
}
